import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';

export default function externalUsersReducer(state = initialstate.externalUsers, action) {
    switch (action.type) {
        case types.GET_EXTERNAL_USERS_LIST: {
			if (!action) return state;

			action.response.users.forEach(function(item) {
				item.isSelected = false;
			});

			return action.response;
        }
        case types.CLEAR_EXTERNAL_USERS: {
			return {};
		}
		case types.ADD_EXTERNAL_SELECTED_USER: {
			if (!action.user) return state;

			let newState = _.cloneDeep(state);

			let index = newState.users.findIndex(
				(user) => user.userId === action.user
			);
			if (index !== -1) {
				newState.users[index].isSelected = true;
			}

			return newState;
		}
		case types.REMOVE_EXTERNAL_SELECTED_USER: {
			if (!action.user) return state;

			let newState = _.cloneDeep(state);

			let index = newState.users.findIndex(
				(user) => user.userId === action.user
			);
			if (index !== -1) {
				newState.users[index].isSelected = false;
			}

			return newState;
		}
		case types.CLEAR_EXTERNAL_ALL_SELECTED_USERS: {
			let newState = _.cloneDeep(action.user);
			newState.users.map((item) => {
				item.isSelected = false;
			});

			return newState;
		}
        default:
            return state;
    }
}


export function externalUserReducer(state = initialstate.externalUser, action) {
    switch (action.type) {
        case types.GET_EXTERNAL_USER_BY_ID: {
            return action.response;
        }
        case types.CLEAR_EXTERNAL_USER: {
			return {};
		}
        default:
            return state;
    }
}
